// routes
import { paths } from 'src/routes/paths';

export const PRODUCTS = [
  {
    title: "Simple Translation Workbench",
    description: "Manage and oversee all translation workflows in one intuitive interface, featuring glossary management, translation memory, and analytics.",
    linkPage: '#',
    linkVideo: 'https://www.youtube.com/watch?v=ndpnK3ZIu08',
    imageSrc: 'assets/icons/home/components/translate.png',
    imageAlt: 'Translation Workbench Icon',
    createdAt: new Date('2024-06-06'),
    buttons: false,
  },
  {
    title: "SimpleT Record AI",
    description: "A Lightning Web Component (LWC) for Salesforce that allows users to add custom AI prompts to Salesforce fields.",
    linkPage: '#',
    linkVideo: 'https://www.youtube.com/watch?v=ndpnK3ZIu08',
    imageSrc: 'assets/icons/home/components/optimize.png',
    imageAlt: 'Record AI Icon',
    labels: ['Lightning Record Pages', 'Screen Flow', 'LWC'],
    createdAt: new Date('2025-06-03'),
  },
  {
    title: "SimpleT File AI",
    description: "AI-powered tool for analyzing and extracting insights from files within Salesforce.",
    linkPage: '#',
    linkVideo: 'https://www.youtube.com/watch?v=ndpnK3ZIu08',
    imageSrc: 'assets/icons/home/components/search_document.png',
    imageAlt: 'File AI Icon',
    labels: ['Lightning Record Pages', 'Screen Flow', 'LWC'],
    createdAt: new Date('2025-06-04'),
  },
  {
    title: "SimpleT Email AI",
    description: "AI assistant for drafting, analyzing, or summarizing emails within Salesforce.",
    linkPage: '#',
    linkVideo: 'https://www.youtube.com/watch?v=ndpnK3ZIu08',
    imageSrc: 'assets/icons/home/components/email.png',
    imageAlt: 'Email AI Icon',
    labels: ['Lightning Record Page'],
    createdAt: new Date('2024-12-06'),
  },
  {
    title: "SimpleT Case Comment AI",
    description: "Tool for generating and improving case comments using AI, simplifying customer service interactions.",
    linkPage: '#',
    linkVideo: 'https://www.youtube.com/watch?v=ndpnK3ZIu08',
    imageSrc: 'assets/icons/home/components/comment.png',
    imageAlt: 'Case Comment AI Icon',
    labels: ['Lightning Record Page', 'Screen Flow', 'LWC'],
    createdAt: new Date('2024-04-12'),
  },
  {
    title: "SimpleT AI Service",
    description: "Core AI backend service allowing the execution of prompts in Salesforce.",
    linkPage: '#',
    linkVideo: 'https://www.youtube.com/watch?v=ndpnK3ZIu08',
    imageSrc: 'assets/icons/home/components/ai-service.png',
    imageAlt: 'AI Service Icon',
    labels: ['Apex', 'Flow'],
    createdAt: new Date('2025-11-03'),
  },
  {
    title: "SimpleT Prompt Builder",
    description: "Enables creation of advanced prompts for any SimpleT AI component, with support for Salesforce data enrichment, external databases, scripting, and testing.",
    linkPage: paths.dashboard.root,
    linkVideo: 'https://www.youtube.com/watch?v=jUkacsMMpdU',
    imageSrc: 'assets/icons/home/components/prompt.png',
    imageAlt: 'SimpleT Prompt Icon',
    labels: ['SimpleT AI Components'],
    createdAt: new Date('2024-02-05'),
  },
  {
    title: "SimpleT Detect Language",
    description: "Automatically detects the language of any text input or field value in Salesforce.",
    linkPage: '#',
    linkVideo: 'https://www.youtube.com/watch?v=ndpnK3ZIu08',
    imageSrc: 'assets/icons/home/components/language_detection.png',
    imageAlt: 'Detect Language Icon',
    labels: ['Apex', 'Flow'],
    createdAt: new Date('2025-04-19'),
  },
  {
    title: "SimpleT Translate",
    description: "Real-time text translation tool within Salesforce for multilingual support.",
    linkPage: paths.dashboard.root,
    linkVideo: 'https://www.youtube.com/watch?v=ndpnK3ZIu08',
    imageSrc: 'assets/icons/home/components/translation_workbench.png',
    imageAlt: 'Translate Icon',
    labels: ['Apex', 'Flow'],
    createdAt: new Date('2024-02-05'),
  },
];
